/* ==========================================================================
   Leather Craftsmanship Theme JavaScript
   AJAX Cart Drawer, Variant Switcher, Mobile Navigation, Accessibility
   ========================================================================== */

document.addEventListener('DOMContentLoaded', () => {
  initCartDrawer();
  initMobileNav();
  initProductForm();
});

function initCartDrawer() {
  const cartButtons = document.querySelectorAll('.js-cart-toggle');
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartOverlay = document.querySelector('.cart-drawer-overlay');
  const cartClose = document.querySelector('.js-cart-close');

  if (!cartDrawer || !cartOverlay) return;

  cartButtons.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      cartDrawer.classList.add('active');
      cartOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  });

  const closeCart = () => {
    cartDrawer.classList.remove('active');
    cartOverlay.classList.remove('active');
    document.body.style.overflow = '';
  };

  if (cartClose) cartClose.addEventListener('click', closeCart);
  cartOverlay.addEventListener('click', closeCart);
}

function initMobileNav() {
  const navToggle = document.querySelector('.js-nav-toggle');
  const mobileNav = document.querySelector('.js-mobile-nav');

  if (!navToggle || !mobileNav) return;

  navToggle.addEventListener('click', () => {
    mobileNav.classList.toggle('active');
  });
}

function initProductForm() {
  const forms = document.querySelectorAll('form[action$="/cart/add"]');

  forms.forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.dataset.originalText = submitBtn.textContent;
        submitBtn.textContent = 'Adding...';
      }

      try {
        const formData = new FormData(form);
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });

        if (response.ok) {
          const item = await response.json();
          updateCartState();
          openCartDrawer();
        } else {
          const err = await response.json();
          alert(err.description || 'Could not add product to cart.');
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
      } finally {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = submitBtn.dataset.originalText || 'Add to Cart';
        }
      }
    });
  });
}

async function updateCartState() {
  try {
    const res = await fetch('/cart.js');
    if (res.ok) {
      const cart = await res.json();
      const countEls = document.querySelectorAll('.cart-count');
      countEls.forEach(el => {
        el.textContent = cart.item_count;
      });
    }
  } catch (err) {
    console.error('Failed to update cart count:', err);
  }
}

function openCartDrawer() {
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartOverlay = document.querySelector('.cart-drawer-overlay');
  if (cartDrawer && cartOverlay) {
    cartDrawer.classList.add('active');
    cartOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
}
